import React, { useEffect, createElement } from 'react';
import { Navigation } from './components/Navigation';
import { FooterNav } from './components/FooterNav';
import { Hero } from './components/Hero';
import { Marquee } from './components/Marquee';
import { Intro } from './components/Intro';
import { ClarityRecap } from './components/ClarityRecap';
import { ApproachTimeline } from './components/ApproachTimeline';
import { WhatsIncluded } from './components/WhatsIncluded';
import { PricingCard } from './components/PricingCard';
import { WeeklyTimeline } from './components/WeeklyTimeline';
import { OptionalSupport } from './components/OptionalSupport';
import { TermsAccordion } from './components/TermsAccordion';
import { ReviewsSection } from './components/ReviewsSection';
import { CTASection } from './components/CTASection';
import { ClientProvider, useClient } from './components/ClientContext';
import { WhatsAppWidget } from './components/WhatsAppWidget';
function AppContent() {
  const {
    clientName
  } = useClient();
  useEffect(() => {
    const meta = document.createElement('meta');
    meta.name = 'robots';
    meta.content = 'noindex, nofollow';
    document.head.appendChild(meta);
    return () => {
      document.head.removeChild(meta);
    };
  }, []);
  return <div className="min-h-screen bg-ivory selection:bg-red/30 selection:text-ink font-sans" data-id="element-0">
      <Navigation data-id="element-1" />
      <FooterNav data-id="element-2" />
      <WhatsAppWidget data-id="element-3" />

      <main data-id="element-4">
        <Hero data-id="element-5" />
        <Marquee text="Clarity · Confidence · Craft · Commercial Direction" data-id="element-6" />
        <Intro data-id="element-7" />
        <ClarityRecap data-id="element-8" />
        <ApproachTimeline data-id="element-9" />
        <WhatsIncluded data-id="element-10" />
        <PricingCard data-id="element-11" />
        <WeeklyTimeline data-id="element-12" />
        <OptionalSupport data-id="element-13" />
        <Marquee text="Brand · Story · Identity · Launch" reverse data-id="element-14" />
        <TermsAccordion data-id="element-15" />
        <ReviewsSection data-id="element-16" />
        <CTASection data-id="element-17" />
      </main>

      <footer className="bg-ink text-ivory/60 py-10 md:py-12 text-center text-xs px-4 border-t border-ivory/10" data-id="element-18">
        <p className="mb-2 font-light italic" data-id="element-19">
          Prepared with care for {clientName}.
        </p>
        <p className="uppercase tracking-[0.2em] text-[10px] text-ivory/40 font-medium" data-id="element-20">
          © 2026 AVY Consultancy Limited
        </p>
      </footer>
    </div>;
}
export function App() {
  return <ClientProvider data-id="element-21">
      <AppContent data-id="element-22" />
    </ClientProvider>;
}